import DeskingApiClient from "../../api/DeskingApiClient";

function initialState() {
  return {
    DeskDealModalInfo: {
      ShowModal: false,
      Data: null
    },
    DeskitMatchingModalInfo: {
      ShowModal: false,
      Data: null
    }
  };
}

const state = initialState();

const getters = {
  DeskitMatchingModalInfo: state => {
    return state.DeskitMatchingModalInfo;
  }
};

const actions = {
  async getDeskingSettings(context, request) {
    let client = new DeskingApiClient();
    let response = await client.ProcessRequest(
      "POST",
      "/api/desking/settings/get_dealer_settings",
      request
    );

    return response.data && response.data.successful && response.data.data
      ? response.data.data
      : null;
  },
  async searchDesks(context, request) {
    let client = new DeskingApiClient();
    let response = await client
      .ProcessRequest("POST", "/api/desking/desk/grouped_search", request)
      .catch(ex => ex.response);
    return response && response.data.successful ? response.data : null;
  },
  async loadDesk(context, request) {
    let client = new DeskingApiClient();
    const response = await client
      .ProcessRequest("POST", "/api/desking/desk/get_desk", request)
      .catch(ex => ex.response);
    if (response && response.data && response.data.data) {
      let desk = response.data.data;
      return desk;
    }
    return [];
  },
  async getPinnedScans(context, request) {
    let client = new DeskingApiClient();
    let response = await client.ProcessRequest(
      "POST",
      "/api/desking/deal/scan/get_pinned_scan_summaries",
      request
    );
    return response && response.data.successful ? response.data : null;
  },
  async createDeskDeal(context, request) {
    let client = new DeskingApiClient();

    // Temporary until API is updated
    if (request && request.trades && request.trades.length > 0)
      request.trades.forEach(trade => {
        trade.dealId = 0;
      });

    let response = await client.ProcessRequest(
      "POST",
      "/api/desking/desk/create",
      request
    );
    return response && response.data.successful ? response.data.data : null;
  },
  updateDeskDealModalInfo: function(context, data) {
    context.commit("updateDeskDealModalInfo", data);
  },
  updateDeskitMatchingModalInfo: function(context, data) {
    context.commit("updateDeskitMatchingModalInfo", data);
  }
};

const mutations = {
  updateDeskDealModalInfo(state, data) {
    state.DeskDealModalInfo = data;
  },
  updateDeskitMatchingModalInfo(state, data) {
    state.DeskitMatchingModalInfo = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/Desking.js